module.exports = "<div class=\"margin-md padding-md\"\r\n    ng-show=\"!$ctrl.data\">\r\n  <progress-circular>Obteniendo información</progress-circular>\r\n</div>\r\n<div ng-if=\"$ctrl.data\">\r\n  <div class=\"ui-grid\"\r\n      ag-grid=\"$ctrl.data\"></div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/nomina/components/bancos/detallado/template.html
// module id = 1063
// module chunks = 0